module.exports = __webpack_public_path__ + "static/media/bg-rally.a2cc0f0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Selection/assets/bg-rally.png
// module id = 195
// module chunks = 0